import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';

import { IDetailedUser } from '../interfaces';
import { DetailedUserMapper } from '../mappers';
import { bind } from '@infra/container';

export type IGetUserByIdRepoResponse = IRepoResponse<200, IDetailedUser> | IRepoResponse<400 | 500, string>;

export type IGetUserByIdRepo = IRepo<[number | string], IGetUserByIdRepoResponse>;

export const GetUserByIdRepoType = Symbol.for('GetUserByIdRepo');

@bind(GetUserByIdRepoType)
export class GetUserByIdRepo implements IGetUserByIdRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(id: number | string) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/client/user', { user_id: id }) });

      if (result.status === 200) {
        const data: IDetailedUser = DetailedUserMapper.toDomain(result.data);

        return {
          status: 200 as 200,
          response: data,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
